import React from "react";

import { Button } from "antd";

import StyledTooltip from "../../../Common/UIComponents/StyledTooltip";

// import closeFilterIcon from "../../../../assets/images/product/lightBlueCancelIcon.png";
import "./SpecButton.css";

class SpecButton extends React.Component {
  render() {
    const toolTipTitle = () => {
      const { disableFilterButton, disabledTooltip, specText } = this.props;
      if (disableFilterButton && disabledTooltip) {
        return disabledTooltip;
      }
      if (specText === "Incomplete" && disableFilterButton) {
        return "No reports are available";
      }
      return "";
    };

    const {
      index,
      specText,
      specColor,
      specSelected,
      disableFilterButton,
      // isActive,
      handleToggleFilter,
    } = this.props;

    const selectedSpecFlags = specSelected ? String(specSelected).split(",").filter(Boolean) : [];
    const isSelected = selectedSpecFlags.includes(String(index));

    return (
      <StyledTooltip
        title={toolTipTitle()}
        placement="top"
      >
        <Button
          disabled={disableFilterButton}
          type={isSelected ? "primary" : "text"}
          ghost={isSelected}
          className={`${isSelected ? "SpecButton__SpecSelected" : "SpecButton__SpecNotSelected"} ${disableFilterButton ? "SpecButton__Spec--disabled" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (disableFilterButton) {
              return;
            }
            handleToggleFilter(index);
          }}
        >
          <div
            className="specCategoryIcon"
            style={{ backgroundColor: specColor }}
          />
          <div className="reportStatusCategory">{specText}</div>
          {/* Close filter icon (top right of spec chip when filter active) — hidden per SpecsBlock__SpecButtonBlock UX
          {isActive && (
          <img
            className="reportStatusCategoryCloseFilterIcon"
            src={closeFilterIcon}
            alt="closeFilterIcon"
            width="14px"
          />
          )}
          */}
        </Button>
      </StyledTooltip>
    );
  }
}

export default SpecButton;
